const FETCH_NDSH7B_REPORT_REQUEST = "FETCH_NDSH7B_REPORT_REQUEST";
const FETCH_NDSH7B_REPORT_SUCCESS = "FETCH_NDSH7B_REPORT_SUCCESS";
const FETCH_NDSH7B_REPORT_FAILURE = "FETCH_NDSH7B_REPORT_FAILURE";

export default {
  FETCH_NDSH7B_REPORT_REQUEST,
  FETCH_NDSH7B_REPORT_SUCCESS,
  FETCH_NDSH7B_REPORT_FAILURE,
};
